import { API_ROOT } from '../../config/config'
import {
  doGet,
  doPost,
  doPut,
  doPostFiles,
  doPutFiles,
  doDownload,
  doDelete,
  doDeleteData,
} from './utils'

// const API_ROOT = 'http://localhost:80/api'

export const callIntellectualProperty = (projectId) => {
  // /api/progress/intellectual-property/page/{projectVersionId}

  const url = `${API_ROOT}/progress/intellectual-property/page/${projectId}`
  return doGet(url)
}

export const saveIntellectualProperty = (request, projectId) => {
  // /api/progress/intellectual-property/save-innovation/{projectVersionId}
  const url = `${API_ROOT}/progress/intellectual-property/save-innovation/${projectId}`
  return doPostFiles(url, request)
}

export const downIntellectualPropertyAttacthment = (fileId) => {
  // /api/progress/download/dip/file
  const url = `${API_ROOT}/progress/download/dip/file/${fileId}`
  return doDownload(url)
}

export const deleteIntellectualPropertyAttacthment = (
  projectVersionId,
  innovationId,
  fileId,
  type
) => {
  // /api/progress/delete/dip/file/{projectVersionId}/{fileId}
  const url = `${API_ROOT}/progress/delete/dip/file/${projectVersionId}/${innovationId}/${fileId}/${type}`
  return doDeleteData(url)
}

export const SaveResearch = (request, projectId) => {
  // /api/progress/intellectual-property/save-research/{projectVersionId}
  const url = `${API_ROOT}/progress/intellectual-property/save-research/${projectId}`
  return doPostFiles(url, request)
}

export const getDownloadFilePath = (filePath) => {
  const url = `${API_ROOT}/progress/file-download?filePath=${filePath}`
  return doDownload(url)
}
